interface PlanHeroProps {
  image: string;
  alt: string;
  // each entry renders on its own line on md+
  titleLines: string[];
  descriptionLines: string[];
  // extra darkening for brighter photos
  dim?: boolean;
  imagePosition?: string;
}

export default function PlanHero({
  image,
  alt,
  titleLines,
  descriptionLines,
  dim = false,
  imagePosition = "tw-object-[right_top]",
}: PlanHeroProps) {
  return (
    // pt-24 keeps the image clear of the fixed 96px header
    <section className="tw-relative tw-w-full tw-bg-black tw-pt-24">
      <div className="tw-relative tw-w-full tw-h-[60vh] md:tw-h-[80vh]">
        <img
          src={`/izicart/${image}`}
          alt={alt}
          className={`tw-w-full tw-h-full tw-object-cover ${imagePosition}`}
        />

        {dim && <div className="tw-absolute tw-inset-0 tw-bg-black/40" />}

        {/* left fade so the text stays readable over the product */}
        <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-black/70 tw-via-black/30 tw-to-transparent" />

        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center">
          <div className="tw-w-full tw-px-6 md:tw-px-[11%]">
            <div>
              <h1 className="tw-text-4xl md:tw-text-5xl tw-font-semibold tw-mb-5 tw-text-white md:[&>span]:tw-block">
                {titleLines.map((line) => (
                  <span key={line}>{line} </span>
                ))}
              </h1>

              {/* line breaks follow the design on md+; text wraps freely on mobile */}
              <p className="tw-text-sm md:tw-text-base tw-leading-relaxed tw-text-white/80 md:[&>span]:tw-block md:[&>span]:tw-whitespace-nowrap">
                {descriptionLines.map((line) => (
                  <span key={line}>{line} </span>
                ))}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
